import { BaseTopMenuBloc } from "./bloc.base";

export class BoxTopMenuBloc extends BaseTopMenuBloc {

}

